<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Recipient Lists</h2>
    <RecipientList />
  </div>
</template>

<script>
import { layouts } from '../helpers'

export default {
  name: 'Recipients',

  components: {
    RecipientList: () => import('@/components/Recipients/Index')
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
</style>
